export const I18N = {
  en: {
    ARTCILES: "Articles",
    Official: "Official",
    Manager: "Manager",
    "Legal Reprentative": "Legal Reprentative",
    "Organization roles": "Organization roles",
    "Blog roles": "Blog roles",
    "Editor-in-chief": "Editor-in-chief",

    CHIEF_EDITOR: "CHIEF EDITOR",
    AUTHOR: "AUTHOR",
    REDACTOR: "REDACTOR",
    LEGAL_REPRESENTATIVE: "LEGAL REPRESENTATIVE",
    MANAGER: "MANAGER",
    OFFICIAL: "OFFICIAL",
    SHAREHOLDER: "SHAREHOLDER",
    QUALITY_MANAGER: "QUALITY MANAGER",
    EXTERNAL: "EXTERNAL",

    Mandated: "Mandated",
    Not_Mandated: "Not Mandated",
  },
  fr: {
    ARTCILES: "Articles",
    Official: "Officiel",
    Manager: "Directeur",
    "Legal Reprentative": "Représentant légal",
    "Organization roles": "Rôles de l'organisation",
    "Blog roles": "Rôles du blog",
    "Editor-in-chief": "Éditeur en chef",

    CHIEF_EDITOR: "Rédacteur en chef",
    AUTHOR: "Auteur",
    REDACTOR: "Rédacteur",
    LEGAL_REPRESENTATIVE: "REPRÉSENTANT LÉGAL",
    MANAGER: "GÉRANT",
    OFFICIAL: "OFFICIEL",
    SHAREHOLDER: "ACTIONNAIRE",
    QUALITY_MANAGER: "RESPONSABLE QUALITÉ",
    EXTERNAL: "EXTERNE",
    Mandated: "Mandaté",
    Not_Mandated: "Non Mandaté",
  },
  nl: {
    ARTCILES: "Artikelen",
    Official: "Officieel",
    Manager: "Manager",
    "Legal Reprentative": "Wettelijke vertegenwoordiger",
    "Organization roles": "organisatie rollen",
    "Blog roles": "blog rollen",
    "Editor-in-chief": "Hoofdredacteur",

    CHIEF_EDITOR: "Hoofdredacteur",
    AUTHOR: "Auteur",
    REDACTOR: "Redacteur",
    LEGAL_REPRESENTATIVE: "WETTELIJKE VERTEGENWOORDIGER",
    MANAGER: "MANAGER",
    OFFICIAL: "OFFICIEEL",
    SHAREHOLDER: "AANDEELHOUDER",
    QUALITY_MANAGER: "KWALITEITSMANAGER",
    EXTERNAL: "EXTERNE",

    Mandated: "gemandateerde",
    Not_Mandated: "niet Gemandateerde",
  },
};
